<!--
 * @Author: 朱占伟
 * @LastEditors: 邱扬
 * @description: 支付渠道底部提示信息
 * @Date: 2021-09-08 18:14:44
 * @LastEditTime: 2022-01-04 09:35:55
-->

<template>
  <div class="payTypes-bottom height-togle text-overflow" @click.stop="toggleStatus">
    <div>
      <van-icon v-show="!statusBottom" name="arrow-down" class="arrow-down" />
      <van-icon v-show="statusBottom" name="arrow-up" class="arrow-up" />
    </div>
    <div class="row">
      <!-- <p
        v-if="detail.type==='EPAY_USDT'"
        :class="{
          'text-overflow': !statusBottom,
          'mt-10': statusBottom,
        }"
      >
        <van-icon name="warning" style="color: #6153ff; font-size: 14px;" />
        <span class="ml-5">Due to the payment system of Epay, you will be charged <span style="color: red; font-weight: bold;">0.2%</span> transaction fee per transaction.</span>
    </p> -->
      <p v-show="detail.type === 'TRIPLE_A'">
        Please ensure that your funding source is regular, otherwise the payment may fail due to strict compliance audits.
      </p>
      <p v-show="detail.type === 'TRIPLE_A'">
        If you belong to one of these countries, please change to another payment method：Cuba, Iran (Islamic Republic Of), Korea (Democratic People's Republic of), Syrian Arab Republic, Ukraine (Only regions of Crimea, Donetsk, Luhansk, Kherson & Zaporizhzhya), Myanmar.
      </p>
      <p
        v-show="maxAmount"
        :class="{
          'text-overflow': maxAmount && !statusBottom,
          'mt-10': statusBottom,
        }"
      >
        <van-icon name="warning" style="color: #6153ff; font-size: 14px" />
        <span
          class="ml-5"
        >If your single payment is larger than
          <span style="color: red; font-weight: bold"> ${{ maxAmount }} </span>, please
          use other payment methods or
          <a class="text-main" @click.stop="contactUs">contact us</a>.</span>
      </p>
    </div>
    <!-- <div class="row"
        v-if="detail.type==='EPAY_USDT'"
        :class="{
          'text-overflow': !statusBottom,
          'mt-10': statusBottom,
        }"
      >
        <van-icon name="warning" style="color: #6153ff; font-size: 14px;" />
        <span class="ml-5">The payment process will take about 15 minutes to make sure your payment.</span>
    </div> -->

    <div class="row">
      <p
        v-if="detail.type === 'EPAY_USDT'"
        :class="{
          'text-overflow': !statusBottom,
          'mt-10': statusBottom,
        }"
      >
        <van-icon name="warning" style="color: #6153ff; font-size: 14px" />
        <span
          class="ml-5"
        >The payment process will take about 15 minutes to make sure your payment, and the speed of transaction processing directly depends on the network congestion and commission of the chosen network. </span>
      </p>
    </div>

    <div class="row">
      <p
        v-if="detail.type === 'PAYOP'"
        :class="{
          'text-overflow': !statusBottom,
          'mt-10': statusBottom,
        }"
      >
        <van-icon name="warning" style="color: #6153ff; font-size: 14px" />
        <span
          class="ml-5"
        >There are some popular crypto payment methods and many local payment methods in
          PayOp channel.</span>
      </p>
    </div>
    <div class="row">
      <p
        v-show="detail.type === 'PAYSSION_BITCOIN'"
        :class="{
          'text-overflow': !statusBottom,
          'mt-10': statusBottom,
        }"
      >
        <van-icon name="warning" style="color: #6153ff; font-size: 14px" />
        <span
          class="ml-5"
        >Please note, cryptocurrency payment will be automatically added to your account
          after we receive 3 or more transaction confirmations. This may take up to 30
          minutes.
        </span>
      </p>
    </div>
    <div class="row">
      <p
        v-show="detail.type === 'PAYSSION_BITCOIN'"
        :class="{
          'text-overflow': !statusBottom,
          'mt-10': statusBottom,
        }"
      >
        <van-icon name="warning" style="color: #6153ff; font-size: 14px" />
        <span class="ml-5">This payment method do not support any refund.</span>
      </p>
    </div>
    <div v-if="detail.storeHint" class="row">
      <p
        :class="{
          'mt-10': detail.type === 'PACY_PAY' || statusBottom,
          'text-overflow': !statusBottom,
        }"
      >
        <van-icon name="warning" style="color: #6153ff; font-size: 14px" />
        <span class="ml-5">{{ detail.storeHint }}</span>
      </p>
    </div>
    <div class="row">
      <p
        :style="{ 'margin-top': !maxAmount && !detail.storeHint ? '' : '10px' }"
        :class="{
          'text-overflow': !maxAmount && !detail.storeHint && !statusBottom,
          'mt-10': statusBottom,
        }"
        class="mb-10"
      >
        <span>By adding money to your account, you automatically accept our </span>
        <a
          target="_blank"
          href="http://asoworld.com/blog/refund-policy-procedure"
          class="text-main"
        >Refund Policy
        </a>
      </p>
    </div>
  </div>
</template>

<script>
import { ref, watch } from "vue";
export default {
  props: {
    detail: {
      type: Object,
      required: true,
      default: () => null,
    },
    maxAmount: {
      type: Number,
      required: true,
      default: () => 0,
    },
    changeFlag: {
      type: Boolean,
      required: true,
      default: () => false,
    },
  },
  setup(props, { emit }) {
    //联系我们
    const contactUs = () => {
      emit("contactUs");
    };

    const activeNames = ref(["1"]);

    let statusBottom = ref(false);
    //点击触发过渡动画
    const toggleStatus = () => {
      statusBottom.value = !statusBottom.value;
      countHeight();
    };
    //计算高度来实现过渡动画
    const countHeight = () => {
      if (!statusBottom.value) {
        document.querySelector(".payTypes-bottom").classList.add("height-togle");
        document.querySelector(".payTypes-bottom").style.height = 40 + "px";
        document.querySelector(".payTypes-bottom").classList.add("text-overflow");
        
      } else {
        

        if (props.maxAmount && props.detail.storeHint) {
          
          if (props.detail.type === "PAYSSION_BITCOIN") {
            document.querySelector(".payTypes-bottom").style.height =
              alltips.value + 100 + "px";
            
          } else {
            document.querySelector(".payTypes-bottom").style.height =
              alltips.value + "px";
            
          }
          document.querySelector(".payTypes-bottom").classList.remove("height-togle");
          document.querySelector(".payTypes-bottom").classList.remove("text-overflow");
        }

        if (!props.maxAmount && props.detail.storeHint && props.detail.type !== "PAYOP") {
          if (props.detail.type === "TEST") {
            document.querySelector(".payTypes-bottom").style.height = "78px";
            
          } else {
            document.querySelector(".payTypes-bottom").style.height =
              storeHint.value + "px";
          }
          

          if (props.detail.type === "EPAY_USDT") {
            document.querySelector(".payTypes-bottom").style.height = "140px";
          }
          document.querySelector(".payTypes-bottom").classList.remove("height-togle");
          document.querySelector(".payTypes-bottom").classList.remove("text-overflow");
        }

        if (!props.maxAmount && !props.detail.storeHint) {
          document.querySelector(".payTypes-bottom").style.height = addtip.value + "px";
          
          document.querySelector(".payTypes-bottom").classList.remove("height-togle");
          document.querySelector(".payTypes-bottom").classList.remove("text-overflow");
        }
        //type为PAYOP
        if (props.detail.type === "PAYOP") {
          
          document.querySelector(".payTypes-bottom").style.height = alltips.value + "px";
          
          document.querySelector(".payTypes-bottom").classList.remove("height-togle");
          document.querySelector(".payTypes-bottom").classList.remove("text-overflow");
        }
      }
    };
    //获取当前设备宽度，根据宽度调整高度
    const addtip = ref(0);
    const storeHint = ref(0);
    const alltips = ref(0);
    const getDeviceWidth = () => {
      const deviceWidth = document.documentElement.clientWidth;
      switch (deviceWidth) {
        case 280:
          addtip.value = 52;
          storeHint.value = 110;
          alltips.value = 168;
          break;
        case 411:
        case 414:
          addtip.value = 52;
          storeHint.value = 94;
          alltips.value = 136;
          break;
        case 540:
          addtip.value = 36;
          storeHint.value = 78;
          alltips.value = 120;
          break;
        default:
          addtip.value = 52;
          storeHint.value = 110;
          alltips.value = 152;
          break;
      }
    };
    getDeviceWidth();

    watch(
      () => props.changeFlag,
      () => {
        countHeight();
      }
    );

    return {
      contactUs,
      activeNames,
      status,
      statusBottom,
      toggleStatus,
      countHeight,
      getDeviceWidth,
    };
  },
};
</script>
<style lang="scss" scoped>
.height-togle {
  height: 40px;
  line-height: 40px;
}

.text-overflow {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.payTypes-bottom {
  position: relative;
  background: #f1f1ff;
  font-size: 12px;
  overflow: hidden;
  transition: height 0.3s;

  & > .row {
    display: flex;
    padding-left: 10px;

    & > p {
      width: 92%;
    }
  }

  .arrow-down,
  .arrow-up {
    position: absolute;
    right: 10px;
    height: 40px;
    line-height: 40px;
  }
}

.text-main {
  text-decoration: underline;
}

.collapse-item {
  :deep(.van-cell) {
    padding: 0;
    height: auto;
    background: #f1f1ff;

    .van-cell__value {
      & > div {
        padding-right: 0;
      }
    }

    .van-cell__right-icon {
      padding-right: 10px;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
    }
  }

  :deep(.van-collapse-item__wrapper) {
    background: #f1f1ff;

    .van-collapse-item__content {
      padding: 0;
    }
  }
}
</style>
